<div class="main_plus_side">
  <div class="main_sheet">
    <div class="flex-wrap" style="flex-flow: row wrap; align-items: baseline; justify-content: space-between;">
      <h2 class="mat-h2">Vigilancia de tareas para {{fechaCalendar.mDate | momentFormat: 'DD [de] MMM [de] YYYY'}}</h2>
      <span class="spacer"></span>
      <mat-form-field>
        <input matInput [matDatepicker]="picker" (dateChange)="changeDate($event.value)" [min]="fechaInicioCalendar"
          [max]="fechaFinCalendar" [formControl]="date" placeholder="Elegir fecha">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <span class="spacer" *ngIf="canNotify$ | async"></span>
      <button mat-raised-button color="primary" [matMenuTriggerFor]="notificationMenu"
        *ngIf="canNotify$ | async">Notificar <mat-icon>arrow_drop_down</mat-icon></button>
      <mat-menu #notificationMenu="matMenu">
        <button mat-menu-item (click)="notify('Profesores')">Profesores</button>
        <button mat-menu-item (click)="notify('Alumnos')">Alumnos</button>
      </mat-menu>
    </div>
    <div class="flex-wrap">
      <mat-form-field style="flex-grow: 7" *ngIf="filteredTeachers$ | async as allTeachers" appearance="outline">
        <mat-label>Profesores en vigilancia</mat-label>
        <mat-chip-set #chipList>
          <mat-chip *ngFor="let propietario of allTeachers.selectedTeachers" [selectable]="selectable"
            [removable]="removable" (removed)="onDeleteTeacher(propietario)">
            {{propietario.apellidosNombres}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip>
          <input placeholder="Profesores en vigilancia" [formControl]="teacherCtrl"
            (keyup)="filterTeachers($event.target.value)" [matAutocomplete]="auto" [matChipInputFor]="chipList">
        </mat-chip-set>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectTeacher($event)">
          <mat-option *ngFor="let owner of allTeachers.teachers" [value]="owner">
            {{owner.apellidosNombres}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="full-width" appearance="outline">
        <!-- <mat-hint>Filtre sobre los campos <i>alumno</i> y <i>materia</i></mat-hint> -->
        <mat-label>Filtre sobre los campos <i>alumno</i> y <i>materia</i></mat-label>
        <input matInput autocomplete="off" (keyup)="filterStudents($event.target.value)">
      </mat-form-field>
    </div>
    <p style="margin-bottom: 18px; color: red; font-size: 80%; text-align: center;">Por favor registre un breve comentario relacionado con el desarrollo que el estudiante
        hizo de la tarea. Todos los estudiantes a su cargo deben tener un comentario al finalizar la sesión, hayan
        asistido o no.</p>
    <div class="full-width" *ngIf="studentsList$ | async as data">
      <h3 class="mat-h3">Alumnos</h3>
      <table mat-table class="full-width mat-elevation-z8" [dataSource]="data">
        <ng-container>
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef>Código</th>
            <td mat-cell *matCellDef="let element">{{element.alumno.codigo}}</td>
          </ng-container>

          <ng-container matColumnDef="alumno">
            <th mat-header-cell *matHeaderCellDef class="padding-emergencia">Alumno</th>
            <td mat-cell *matCellDef="let element" class="padding-emergencia">{{element.alumno.apellidosNombres}}</td>
          </ng-container>

          <ng-container matColumnDef="materia">
            <th mat-header-cell *matHeaderCellDef class="padding-emergencia">Materia</th>
            <td mat-cell *matCellDef="let element" class="padding-emergencia">{{element.materia.nombreCompleto}}</td>
          </ng-container>

          <ng-container matColumnDef="tarea">
            <th mat-header-cell *matHeaderCellDef class="padding-emergencia">Tarea</th>
            <td mat-cell *matCellDef="let element" class="padding-emergencia">{{element.faltaTarea.fecha | momentFormat: 'DD-MMM'}} {{element.faltaTarea.comentario}}</td>
          </ng-container>

          <ng-container matColumnDef="comentario">
            <th mat-header-cell *matHeaderCellDef class="padding-emergencia">Comentario</th>
            <td mat-cell *matCellDef="let element" class="padding-emergencia" style="overflow: hidden">
              <mat-form-field appearance="outline" style="margin-top: 16px">
                <mat-label>Comentario</mat-label>
                <textarea matInput (keyup)="updateComment($event.target.value, element.faltaTarea, savingTA)"
                  [value]="element.faltaTarea.comentarioRevision" 
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  [disabled]="!element.faltaTarea.isEditable"></textarea>
                <div #savingTA style="display: none;">
                  <br>
                  <mat-spinner [diameter]="12"></mat-spinner>
                </div>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="asistencia">
            <th mat-header-cell *matHeaderCellDef>Asistió</th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox (change)="setPresentState($event.checked, element.faltaTarea)"
                [checked]="element.faltaTarea.asistio" [disabled]="!element.faltaTarea.isEditable"></mat-checkbox>

            </td>
          </ng-container>

        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
      </table>
      <div *ngIf="data.length === 0">No hay registros para la fecha seleccionada.</div>
    </div>
    <div class="alert alert-danger" style="background: rgba(255, 0, 0, .7)"
      *ngIf="errorMessage$ | async as errorMessage">
      {{ errorMessage }}
    </div>

    <mat-spinner *ngIf="loading"></mat-spinner>

  </div>
</div>
